<div class="container-fluid px-0">
    <div class="row mx-0 pt-3">
        <div class="col-md-6 col-lg-6 col-xl-3 pe-3 ps-0">
            <div class="">
                <app-input 
                onlyNumbers
                [inputLabel]="'Pin Count'" 
                [inputType]="'text'" 
                [inputValue]="formModel?.additionalDetailsModel?.pinCount"
                (inputValueEmit)="formModel.additionalDetailsModel.pinCount =$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
             </div>
             <div class="py-4">
                <app-input 
                [inputLabel]="'Lead Shape'" 
                [inputType]="'text'" 
                [inputValue]="formModel?.additionalDetailsModel?.leadShape"
                (inputValueEmit)="formModel.additionalDetailsModel.leadShape =$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
            </div>
            <div class="pb-4">
                <app-input 
                [inputLabel]="'Dimensions (W x L x H) '" 
                [inputType]="'text'" 
                [inputValue]="formModel?.additionalDetailsModel?.dimensions"
                (inputValueEmit)="formModel.additionalDetailsModel.dimensions=$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
            </div>
            <div class="pb-4 pb-md-0">
                <app-input 
                onlyNumbers
                [inputLabel]="'Storage Temp'" 
                [inputType]="'text'" 
                [inputValue]="formModel?.additionalDetailsModel?.storageTemp"
                (inputValueEmit)="formModel.additionalDetailsModel.storageTemp =$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
            </div>

        </div>
        <div class="col-md-6 col-lg-6 col-xl-3 order-lg-2 pt-lg-4 order-md-2 order-xl-1 pt-md-4 pt-xl-0 ps-0 pe-3 px-lg-3">
            <div class="">
                <app-input 
                [inputLabel]="'Backlighting'" 
                [inputType]="'text'" 
                [inputValue]="formModel?.additionalDetailsModel?.backLighting"
                (inputValueEmit)="formModel.additionalDetailsModel.backLighting =$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
            </div>
            <div class="py-4">
                <app-input 
                [inputLabel]="'Brightness'" 
                [inputType]="'text'" 
                [inputValue]="formModel?.additionalDetailsModel?.brightness"
                (inputValueEmit)="formModel.additionalDetailsModel.brightness =$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
            </div>
            <div class="pb-4">
                <app-input 
                onlyNumbers
                [inputLabel]="'Resolution'" 
                [inputType]="'text'" 
                [inputValue]="formModel?.additionalDetailsModel?.resolution"
                (inputValueEmit)="formModel.additionalDetailsModel.resolution =$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
            </div>
            <div class="pb-4 pb-md-0">
                <app-input 
                onlyNumbers
                [inputLabel]="'Contrast Ratio'" 
                [inputType]="'text'" 
                [inputValue]="formModel?.additionalDetailsModel?.contrastRatio"
                (inputValueEmit)="formModel.additionalDetailsModel.contrastRatio =$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
               </div>

        </div>
        <div class="col-md-6 col-lg-6 col-xl-3 order-md-1 order-lg-1 ps-0 ps-md-3 pe-3 pe-md-0">
            <div class="">
                <app-input 
                onlyNumbers
                [inputLabel]="'Supply Voltage'" 
                [inputType]="'text'" 
                [inputValue]="formModel?.additionalDetailsModel?.supplyVoltage"
                (inputValueEmit)="formModel.additionalDetailsModel.supplyVoltage =$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
            </div>
            <div class="py-4">
                <app-input 
                [inputLabel]="'SKU'" 
                [inputType]="'text'" 
                [inputValue]="formModel?.additionalDetailsModel?.sku"
                (inputValueEmit)="formModel.additionalDetailsModel.sku =$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
               </div>
               <div class="pb-4">
                <app-dropdown
                [selectLabel]="'UoM'"
                [data]="getAllDropdown?.uomList"
                [selectValue]="formModel?.additionalDetailsModel?.uomId"
                (selectValueEmit)="formModel.additionalDetailsModel.uomId = $event"
                [required]="false"
              >
              </app-dropdown>
               </div>
        </div>

        <div class="col-md-6 col-lg-6 col-xl-3 order-lg-2 order-xl-1 pt-lg-4 order-md-2 pt-md-4 pt-xl-0" >
        </div>
    </div>
</div>